import { useParams, Link } from 'react-router-dom';
import { articles } from '../data/content';
import './BlogArticle.css';

const articleContent = {
  'eliminar-planilhas-excel': {
    body: [
      'Planilhas Excel são ótimas para análises pontuais, mas viram gargalo quando se tornam o sistema principal da empresa.',
      'Sem controle de versão, sem histórico de alterações e sem integração com outros sistemas, o retrabalho cresce e os erros se multiplicam.',
      'A migração para um sistema web sob medida permite centralizar dados, controlar acessos e automatizar fluxos que hoje dependem de cópias manuais.',
    ],
  },
  'custo-processo-manual': {
    body: [
      'Cada vez que um colaborador digita a mesma informação em dois lugares diferentes, a empresa paga duas vezes pelo mesmo trabalho.',
      'Processos manuais consomem horas que poderiam ser investidas em atividades estratégicas.',
      'Automatizar não é luxo — é redução direta de custo operacional.',
    ],
  },
  'apis-rest': {
    body: [
      'APIs REST são a ponte entre sistemas que não conversam nativamente.',
      'Com integrações bem projetadas, dados fluem automaticamente entre ERP, CRM, financeiro e outras aplicações.',
      'Isso elimina silos de informação e reduz erros de digitação.',
    ],
  },
  'ia-aplicada-rh': {
    body: [
      'Inteligência Artificial está transformando processos de RH: classificação de documentos, triagem de solicitações e análise de dados de pessoas.',
      'Desde a leitura automática de atestados até assistentes que respondem dúvidas de colaboradores, a IA complementa o portal de RH.',
      'O segredo é aplicar IA onde há volume repetitivo e decisões baseadas em padrões.',
    ],
  },
  'automatizando-compras': {
    body: [
      'Compras por e-mail geram atrasos, falta de rastreabilidade e dificuldade de comparar cotações.',
      'Um portal de solicitações com workflow de aprovação e integração com fornecedores elimina o caos.',
      'Do pedido ao recebimento, tudo fica registrado e conectado ao estoque e financeiro.',
    ],
  },
  'integracao-erp-crm': {
    body: [
      'Quando ERP e CRM não conversam, dados comerciais ficam desatualizados e o financeiro recebe informações com atraso.',
      'Integrações via APIs REST sincronizam cadastros, pedidos e faturamento em tempo real.',
      'Sua equipe comercial e financeira trabalha com a mesma verdade, sem retrabalho.',
    ],
  },
};

function BlogArticle() {
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug);
  const content = articleContent[slug];

  if (!article) {
    return (
      <div className="page-hero">
        <h1>Artigo não encontrado</h1>
        <Link to="/blog" className="btn btn-outline">Voltar aos artigos</Link>
      </div>
    );
  }

  return (
    <div className="article-page">
      <div className="page-hero">
        <Link to="/blog" className="back-link">← Voltar aos artigos</Link>
        <h1>{article.title}</h1>
        <p>{article.excerpt}</p>
      </div>

      <article className="section">
        <div className="container article-body">
          {content?.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          <div className="article-cta">
            <p>Quer aplicar isso na sua empresa?</p>
            <Link to="/diagnostico" className="btn btn-primary">Solicitar diagnóstico gratuito</Link>
          </div>
        </div>
      </article>
    </div>
  );
}

export default BlogArticle;
